import React, { Component } from 'react';
import CustomerSearch from '../customers/CustomerSearch';

class CustomerHold extends Component {
    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Customer Hold</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <CustomerSearch hold={true} paramsKey="params.customer-hold">
                        </CustomerSearch>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerHold;
